<template>
  <div>
    <div class="row" style="padding-bottom: 10px">
      <div class="col-md-2">
        <label for="starDate">{{$t('Tarixdən')}}</label>
        <el-date-picker size="small" id="starDate" format="dd.MM.yyyy" type="date" :clearable="false"
          v-model="item.startDate">
        </el-date-picker>
      </div>
      <div class="col-md-2">
        <label for="endDate">{{$t('Tarixədək')}}</label>
        <el-date-picker size="small" id="endDate" format="dd.MM.yyyy" type="date" :clearable="false"
          v-model="item.endDate">
        </el-date-picker>
      </div>
      <div class="col-md-8" style="padding-bottom: 10px">
       <label>{{$t('Axtarış_növü')}}</label>
        <div class="d-flex justify-content-start">
          <div class="d-flex flex-row">

            &nbsp;
            <el-button size="small" type="primary" icon="el-icon-search" @click="clickSearch"></el-button>
            &nbsp;
            <download-excel :fields="cellsForExport" :data="exportDataList" worksheet="My Worksheet" name="responses">
              <el-button size="small" @click="exportData" type="info"><i class="fa-solid fa-download"></i> {{$t('Export')}}
              </el-button>
            </download-excel>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <el-table :default-expand-all="true" v-loading="loading" :data="displayData.filter(
          (data) =>
            !search ||
            data.regionName.toLowerCase().includes(search.toLowerCase()) ||
            data.dispAccidentNumber.toString().includes(search)
        )
          " style="width: 100%">
          <el-table-column :label="$t('Hadisə_nömrəsi')" sortable prop="dispAccidentNumber" width="170"></el-table-column>
          <el-table-column :label="$t('Qeydiyyata_alan')" prop="createUserName" sortable width="160"></el-table-column>
          <el-table-column :label="$t('Qəza_komissarı')" sortable prop="accidentCommUserName" width="180"></el-table-column>
          <el-table-column :label="$t('Region')" sortable prop="regionName" width="120"></el-table-column>
          <el-table-column :label="$t('Ərazi')" sortable prop="fullPlace" width="200"></el-table-column>
          <el-table-column :label="$t('Hadisə_ünvanı')" sortable prop="place" width="160"></el-table-column>
          <el-table-column :label="$t('Ç.M_Qeydiyyat_tarixi')" sortable prop="callCreateDate_Date"
            width="200"></el-table-column>
          <el-table-column :label="$t('Ç.M_Qeydiyyat_vaxtı')" sortable prop="callCreateDate_Time"
            width="200"></el-table-column>
          <el-table-column :label="$t('Q.K_Qəbul_tarixi')" sortable prop="createDate_Date" width="200"></el-table-column>
          <el-table-column :label="$t('Q.K_Qəbul_vaxtı')" sortable prop="createDate_Time" width="200"></el-table-column>
          <el-table-column :label="$t('Qəbul_müddəti')" sortable prop="admissionPeriod" width="200"></el-table-column>
          <el-table-column :label="$t('Hadisəyə_çıxış_tarixi')" sortable prop="departureDate_Date"
            width="200"></el-table-column>
          <el-table-column label="Hadisəyə çıxış vaxtı" sortable prop="departureDate_Time"
            width="200"></el-table-column>
          <el-table-column :label="$t('Baxış_tarixi')" sortable prop="observationDate_Date" width="150"></el-table-column>
          <el-table-column :label="$t('Baxış_vaxtı')" sortable prop="observationDate_Time" width="150"></el-table-column>
          <el-table-column :label="$t('Hadisəyə_çatma_müddəti')" sortable prop="arrivalTerm" width="140"></el-table-column>
          <el-table-column :label="$t('Hadisəyə_çıxış_müddəti')" sortable prop="departureTerm" width="120"></el-table-column>
          <el-table-column  :label="$t('Ayrılma_tarixi')" sortable prop="leaveDate_Date" width="140"></el-table-column>
          <el-table-column   :label="$t('Ayrılma_vaxtı')"  sortable prop="leaveDate_Time" width="140"></el-table-column>
          <el-table-column :label="$t('Baxış_müddəti')" sortable prop="observationTerm" width="160"></el-table-column>
          <el-table-column :label="$t('Ümumi_tənzimləmə_müddəti')"  sortable prop="totalAdjustmentPeriod"
            width="160"></el-table-column>




        </el-table>
        <div style="text-align: center">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="filter.page" :page-sizes="[10, 30, 50, 100, 200]" :page-size="filter.pagesize"
            layout="sizes, prev, pager, next" :total="totalRecords">
          </el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { DateToString, AddMonths, AddDays } from "../../services/helper";
import {
  GetAccidentDetailsFull,
} from "src/services/report";
export default {
  data() {
    return {
      loading: false,
      data: [],
      exportDataList: [],
      totalRecords: 0,
      search: "",
      uid: this.$store.state.user.id,
      item: {
        startDate: null,
        endDate: null,
        dataExport: 0,
        pageSize:10,
        pageNumber:1
      },
      displayData: [],
      filter: {
        page: 1,
        pagesize: 50,
      },

    };

  },
  computed: {
    cellsForExport() {
      let cells = {
        'Hadisə #': 'dispAccidentNumberExport',
        'Qeydiyyata alan': 'createUserName',
        'Qəza komissarı': 'accidentCommUserName',
        'Region': 'regionName',
        'Ərazi': 'fullPlace',
        'Hadisə ünvanı': 'place',
        'Ç.M Qeydiyyat tarixi ': 'callCreateDate_Date',
        'Ç.M Qeydiyyat vaxtı': 'callCreateDate_Time', 
        'Q.K Qəbul tarixi': 'createDate_Date', 
        'Q.K Qəbul vaxtı': 'createDate_Time',
        'Qəbul müddəti': 'admissionPeriod', 
        'Hadisəyə çıxış tarixi':'departureDate_Date',
        'Hadisəyə çıxış vaxtı':'departureDate_Time',
        'Baxış tarixi':'observationDate_Date',
        'Baxış vaxtı':'observationDate_Time',
        'Hadisəyə çatma müddəti': 'arrivalTerm', 
        'Hadisəyə çıxış müddəti': 'departureTerm', 
        'Ayrılma tarixi': 'leaveDate_Date', 
        'Ayrılma vaxtı': 'leaveDate_Time', 
        'Baxış müddəti': 'observationTerm', 
        'Ümumi tənzimləmə müddəti': 'totalAdjustmentPeriod', 
      };



      return cells;
    }
  },
  methods: {

    clickSearch() {
      this.filter.page = 1
      this.getData();
    },

    loadTime() {
      this.item.startDate = AddDays(new Date(), -1);
      this.item.endDate = new Date();
    },


    async getData() {
      this.loading = true;
      try {
        if (this.item.searchText === "") {
          this.item.searchText = null;
        }
        const params = {
          startDate: DateToString(this.item.startDate),
          endDate: DateToString(this.item.endDate),
          pageSize: this.filter.pagesize,
          pageNumber: this.filter.page,
          dataExport: this.item.dataExport
        };
        const response = await GetAccidentDetailsFull(params);
        if (response.data) {
          this.data = response.data.map(item => ({
            ...item,
            dispAccidentNumberExport: item.dispAccidentNumber ? `${item.dispAccidentNumber.toString().padStart(7, '0')}\u200B` : '',
            createDate_Date: item.createDate_Date === "01.01.0001" ? "" : `${item.createDate_Date}`,
            createDate_Time: item.createDate_Date === "01.01.0001" && item.createDate_Time === "00:00" ? "" : `${item.createDate_Time}`,
            admissionPeriod: item.admissionPeriod === "00:00" ? '' : `${item.admissionPeriod}`,
            arrivalTerm:  item.arrivalTerm === "00:00" ? '' : `${item.arrivalTerm}`,
            departureDate_Date: item.departureDate_Date === "01.01.0001" ? "" : `${item.departureDate_Date}`,
            departureDate_Time: item.departureDate_Date === "01.01.0001" && item.departureDate_Time === "00:00" ? "" : `${item.departureDate_Time}`,
            departureTerm:  item.departureTerm === "00:00" ? '' : `${item.departureTerm}`,
            leaveDate_Date:  item.leaveDate_Date === "01.01.0001" ? "" : `${item.leaveDate_Date}`,
            leaveDate_Time:  item.leaveDate_Date === "01.01.0001" && item.leaveDate_Time === "00:00" ? "" : `${item.leaveDate_Time}`,
            observationDate_Date: item.observationDate_Date === "01.01.0001" ? "" : `${item.observationDate_Time}`,
            observationDate_Time: item.observationDate_Date === "01.01.0001" && item.observationDate_Time === "00:00" ? "" : `${item.observationDate_Time}`,
            observationTerm: item.observationTerm === "00:00" ? '' : `${item.observationTerm}`,
            totalAdjustmentPeriod: item.totalAdjustmentPeriod === "00:00" ? '' : `${item.totalAdjustmentPeriod}`,
            callCreateDate_Date: item.callCreateDate_Date === "01.01.0001" ? "" : `${item.callCreateDate_Date}`,
            callCreateDate_Time: item.callCreateDate_Date === "01.01.0001" && item.callCreateDate_Time === "00:00" ? "" : `${item.callCreateDate_Time}`
          }));
          this.displayData = this.data;
          this.totalRecords = response.data?.[0].totalRecords;
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.loading = false;
      }
    },
    exportData() {
      this.item.startDate = DateToString(this.item.startDate);
      this.item.endDate = DateToString(this.item.endDate);
      this.item.dataExport = 1;
      GetAccidentDetailsFull(this.item).then((response) => {
        if (response.data) {
          this.exportDataList = response.data;
        }
      }).finally(() => {
        this.item.dataExport = 0;
      });
    },
    handleCurrentChange(val) {
      this.filter.page = val;
      this.getData();
    },

    handleSizeChange(val) {
      this.filter.pagesize = val;
      this.getData();
    },
  },
  mounted() {
    this.loadTime();
    this.getData();
  },
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>